"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIREBASE_CONFIG = exports.VERSE_CLAIM_CONTRACT = exports.WSS_PRICE = exports.WSS_PORTFOLIO = exports.WSS_TRANSACTION = exports.BASE_MARKETS_URL = exports.AXIOS_CONFIG = exports.API_V2_URL = exports.API_URL = void 0;
var activeEnv = process.env.DEPLOY_ENV || process.env.NODE_ENV || 'development';
var BASE_DOMAIN = process.env.NEKO_BASE_URL;
/** NEKO WEB API */
var DEV_BASE = "tradfi-web.ops.bitcoin.com";
// const DEV_BASE: string = `http://localhost:1339`;
var PROD_BASE = "neko-web.api.wallet.bitcoin.com";
var FALLBACK_URL = activeEnv === 'production' ? PROD_BASE : DEV_BASE;
var BASE_URL = BASE_DOMAIN !== undefined ? BASE_DOMAIN : FALLBACK_URL;
exports.API_URL = "https://".concat(BASE_URL, "/api/v1");
exports.API_V2_URL = "https://".concat(BASE_URL, "/api/v2");
exports.AXIOS_CONFIG = {
    withCredentials: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
};
/** MARKETS */
exports.BASE_MARKETS_URL = "https://markets.api.bitcoin.com";
/** NEKO WEB WEBSOCKETS */
var DEV_WSS_BASE = "wss://".concat(BASE_URL, "/api/v1/socket");
var DEV_MARKETS_WSS_BASE = "wss://markets-ws.ops.bitcoin.com";
// const DEV_WSS_BASE = 'ws:localhost:1339/api/v1/socket';
var PROD_WSS_BASE = "wss://".concat(BASE_URL, "/api/v1/socket");
var PROD_MARKETS_WSS_BASE = "wss://markets-ws.api.bitcoin.com";
var WSS_BASE_URL = activeEnv === 'production' ? PROD_WSS_BASE : DEV_WSS_BASE;
var MARKETS_WSS_BASE_URL = activeEnv === 'production' ? PROD_MARKETS_WSS_BASE : DEV_MARKETS_WSS_BASE;
exports.WSS_TRANSACTION = "".concat(WSS_BASE_URL, "/transaction");
exports.WSS_PORTFOLIO = "".concat(WSS_BASE_URL, "/portfolio");
exports.WSS_PRICE = "".concat(MARKETS_WSS_BASE_URL, "/v1/live-price");
exports.VERSE_CLAIM_CONTRACT = '0xE5aC5142BdE69cfA722662D9C3E4C8111f60B8d5';
/** FIREBASE SDK FOR REFERRALS */
exports.FIREBASE_CONFIG = {
    apiKey: 'AIzaSyDaI5F3JuT-aj_qhZmpAp2Ro-UA-XkPehQ',
    authDomain: 'dex-referrals-b2858.firebaseapp.com',
    projectId: 'dex-referrals-b2858',
    storageBucket: 'dex-referrals-b2858.appspot.com',
    messagingSenderId: '791391942279',
    appId: '1:791391942279:web:62006dbf7e1f932ae2aa22',
    databaseUrl: 'https://dex-referrals-b2858-default-rtdb.firebaseio.com/',
};
